import { enrichRepeatCard } from './enrich-repeat-card'
import { enrichRespondCard } from './enrich-respond-card'
import { enrichMCCard } from './enrich-mc-card'
import { enrichShortAnswerCard } from './enrich-short-answer-card'

import { type BulkImportStore } from '@/components/BulkImportModal/store/bulk-import.store.types'
import { type CardActivityType, type CardActivityWithId } from '@/models/card-activity/card-activity.model'
import { checkTypeCardActivity } from '@/utils/checkTypeCard'
import {
  logGenerateAnswersFail,
  logGenerateAnswersSuccess,
  logGenerateCriteriaWithAiFail,
  logGenerateCriteriaWithAiSuccess,
  logGenerateTranslationsFail,
  logGenerateTranslationsSuccess,
  logImportCardsFail,
  logImportCardsSuccess,
} from '@/lib/firebase_analyics/bulk-import-analytics'

interface BuildCardTableData {
  cardType: BulkImportStore['cardType']
  cardsDraft: BulkImportStore['cardsDraft']
  settings: BulkImportStore['settings']
}

export const buildCardTableData = async ({ cardType, cardsDraft, settings }: BuildCardTableData) => {
  const { isMC, isRepeat, isRespond, isShortAnswer } = checkTypeCardActivity(cardType as CardActivityType)

  const enrichmentPromises = Array.from(cardsDraft.entries()).map(async ([cardId, cardDraft]) => {
    const cardDraftWithId = { ...cardDraft, id: cardId }
    let enriched: Partial<CardActivityWithId> = {}

    if (isRepeat) {
      enriched = await enrichRepeatCard(cardType as CardActivityType, cardDraftWithId, settings)
    }

    if (isRespond) {
      enriched = await enrichRespondCard(cardType as CardActivityType, cardDraftWithId, settings)
    }

    if (isMC) {
      enriched = await enrichMCCard(cardType as CardActivityType, cardDraftWithId, settings)
    }

    if (isShortAnswer) {
      enriched = await enrichShortAnswerCard(cardType as CardActivityType, cardDraftWithId, settings)
    }

    return [cardId, enriched as CardActivityWithId] as const
  })

  try {
    const enrichedCards = await Promise.all(enrichmentPromises)

    logImportCardsSuccess({
      cardType: cardType as CardActivityType,
      numberOfCards: cardsDraft.size,
    })

    if (isRepeat && settings.generateTranslations) {
      logGenerateTranslationsSuccess({
        numberOfCards: cardsDraft.size,
      })
    }

    if (isMC && settings.generateAnswers) {
      logGenerateAnswersSuccess({
        numberOfCards: cardsDraft.size,
      })
    }

    if (isRespond && settings.generateTranslations) {
      logGenerateCriteriaWithAiSuccess({
        numberOfCards: cardsDraft.size,
      })
    }

    if (isShortAnswer && settings.generateAnswers) {
      logGenerateAnswersSuccess({
        numberOfCards: cardsDraft.size,
      })
    }

    return new Map(enrichedCards)
  } catch (error) {
    logImportCardsFail({
      cardType: cardType as CardActivityType,
      numberOfCards: cardsDraft.size,
    })

    if (isRepeat && settings.generateTranslations) {
      logGenerateTranslationsFail({
        numberOfCards: cardsDraft.size,
      })
    }

    if (isMC && settings.generateAnswers) {
      logGenerateAnswersFail({
        numberOfCards: cardsDraft.size,
      })
    }

    if (isRespond && settings.generateTranslations) {
      logGenerateCriteriaWithAiFail({
        numberOfCards: cardsDraft.size,
      })
    }

    if (isShortAnswer && settings.generateAnswers) {
      logGenerateAnswersFail({
        numberOfCards: cardsDraft.size,
      })
    }
  }
}
